import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=60400d90&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=60400d90&prod&lang=scss&scoped=true&"
import style1 from "./Player.vue?vue&type=style&index=1&id=60400d90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60400d90",
  null
  
)

export default component.exports